import React from "react";
import { Stack, Text, Button, Alert, Paper } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { Display } from "@/utils/api/DisplayService";

export interface DisplayLinkSuccessProps {
  /** The display that was successfully linked */
  display: Display;

  /** Optional success message */
  message?: string;

  /** Optional action button text */
  actionText?: string;

  /** Optional action button handler */
  onAction?: () => void;
}

export const DisplayLinkSuccess: React.FC<DisplayLinkSuccessProps> = ({
  display,
  message = "Display successfully linked!",
  actionText,
  onAction,
}) => {
  return (
    <Stack align="center" gap="lg" style={{ maxWidth: 500, margin: "0 auto" }}>
      <Alert
        icon={<IconCheck size="1rem" />}
        title="Success"
        color="green"
        variant="light"
        style={{ width: "100%" }}
      >
        <Text size="sm">{message}</Text>
      </Alert>

      <Paper p="md" withBorder style={{ width: "100%" }}>
        <Stack gap="xs">
          <Text size="sm" c="dimmed">
            Linked Display:
          </Text>
          <Text size="md" fw={500}>
            {display.name || "Unnamed Display"}
          </Text>
          {display.description && (
            <Text size="sm" c="dimmed">
              {display.description}
            </Text>
          )}
        </Stack>
      </Paper>

      {actionText && onAction && (
        <Button onClick={onAction} variant="filled" color="green">
          {actionText}
        </Button>
      )}
    </Stack>
  );
};
